<mat-toolbar color="primary">
  <span id="dokument-send-til-signering-dialog-tittel">
    {{ "Send '{filnavn}' til signering" |translate: {filnavn:dokumentversjon.pdfFilnavn} }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

@if (modus() == 'send') {
  <form [formGroup]="skjema" (ngSubmit)="sendTilSignering()" class="send-til-signering" data-testid="dokument-send-til-signering-skjema">
    <mat-dialog-content>
      <fieldset>
        <mat-form-field>
          <mat-label>{{ 'Gruppemedlemmer som skal signere'|translate }}</mat-label>
          <velg-medlemmer [skjemakontroll]="skjema.controls.signatarer" [medlemmer]="valgbareMedlemmer()"/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>
            {{ "Skriv inn beskjed inkludert i invitasjonen"|translate }}
          </mat-label>
          <riktekst-redigering [skjemakontroll]="skjema.controls.beskjed" data-testid="beskjed-felt"/>
        </mat-form-field>
      </fieldset>

      <h4>{{ 'Signeringsmåte'|translate }}</h4>
      <p>{{ 'Velg hvordan brukere skal signere dokumentet. Du kan velge en eller flere metoder.'|translate }}</p>
      <signering-velg-aksepterte-metoder [skjemaKontroll]="skjema.controls.signaturmetoder"/>
      @if (skjema.controls.signaturmetoder.hasError('required')) {
        <div class="feilmelding">{{ 'Angi minst én signaturmåte'|translate }}</div>
      }
      @if(valideringsfeil().length > 0){
        <inline-melding type="feil" voksHorisontalt="true" data-testid="valideringsfeil">
          {{'Sending til signering feilet med følgende:'|translate}}
          <ul>
            @for(feil of valideringsfeil(); track $index){
              <li>{{feil}}</li>
            }
          </ul>
        </inline-melding>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <span>
        <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
        <submit-button [skjema]="skjema" [arbeidPaagaar]="lagrer()" spinnerTekst="{{'Sender...'|translate}}">
          {{ "Send signeringsinvitasjon"|translate }}
        </submit-button>
      </span>
      <mat-checkbox [formControl]="skjema.controls.huskSignaturmetodeValg"
                    [style.visibility]="signaturmetoderEndret()?'visible':'hidden'"
                    matTooltip="{{'Bruk dette som standard ved signering i denne gruppen'|translate}}">
        {{ 'Husk signeringsmåte' | translate }}
      </mat-checkbox>
    </mat-dialog-actions>
  </form>
}

@else if (modus() == 'kvittering') {
  <mat-dialog-content class="kvittering" data-testid="kvittering-send-til-signering">
    <p class="bekreftelse">{{ 'Invitasjon har blitt sendt til {antall} personer.'|translate: {antall: skjema.value.signatarer.length} }}</p>
    <tips>
      <p>{{ 'Du finner en oversikt over manglende signaturer for alle dokumenter sendt til signering på'|translate }} <a (click)="gaaTilHjemskjermen()">{{ 'hjem-skjermen'|translate }}</a>.</p>
      <p>{{ 'Hvem som signerer og hvilken signeringsmetode som benyttes kan endres helt frem til alle har signert.'|translate }}</p>
      <p>{{ 'Når dokumentet er ferdig signert legger Styreplan til en forside med signaturinformasjon. Den tekniske/juridiske signaturdokumentasjonen ligger som vedlegg i denne PDFen.'|translate }}</p>
    </tips>
    <melding-sendt-ikon/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <div>
      <button mat-raised-button color="primary" type="button" (click)="ferdig()" cdkFocusInitial data-testid="ferdig">
        {{ 'Lukk'|translate }}
      </button>
    </div>
  </mat-dialog-actions>
}

